import { fetch } from "state/utils";
import { store } from "state/store";
import { refreshToken } from "views/pages/Store/Products/ProductSuggestions/adminApi";

/**
 * « À la carte » — aperçu de la carte du tunnel B2C, en lecture seule et hors
 * middleware Redux (deux GET, aucun état à partager avec une autre vue).
 * Endpoints : GET /api/v2/admin/store/carte-preview[.json|/establishments.json]
 * (lemoulinapi, ROLE_ADMIN exigé côté serveur).
 *
 * On passe par `state/utils/fetch` — le MÊME utilitaire que le middleware Redux —
 * et pas par un axios monté à la main : c'est lui qui pose l'en-tête Basic exigé
 * en environnement `staging` (REACT_APP_ENV), en plus du jeton. Un appel axios
 * direct fonctionne en local et se fait refuser une fois déployé.
 *
 * Hors middleware, pas de refresh automatique du JWT : sans le `get` ci-dessous,
 * l'onglet affichait « JWT Token expired » quand les autres onglets, eux,
 * rafraîchissaient le jeton en silence.
 */

const baseUrl = process.env.REACT_APP_LEMOULIN_API_URL;
const apiKey = process.env.REACT_APP_LEMOULIN_API_KEY;

/** L'API enveloppe toutes ses réponses dans { code, result } — on déballe ici. */
const unwrap = (res) => res.data.result;

const token = () => store.getState().session?.token || window.localStorage.getItem("token");

/** GET authentifié : sur un 401 (jeton expiré), refresh puis un seul nouvel essai. */
const get = (url, params) =>
  fetch(url, "GET", params, token()).catch((err) => {
    if (err?.response?.status !== 401) {
      throw err;
    }
    return refreshToken().then((fresh) => fetch(url, "GET", params, fresh));
  });

/** Établissements proposés aux deux sélecteurs de site. */
export function getEstablishments() {
  return get(
    `${baseUrl}/v2/admin/store/carte-preview/establishments.json?apiKey=${apiKey}`
  ).then(unwrap);
}

/**
 * Offre annotée pour un contexte.
 * @param {Object} params { establishment, date (Y-m-d), for ('shop'|'spot') }
 * @returns {Promise} resolve avec { _meta: { counts }, sections: [...] }
 */
export function getCartePreview(params) {
  return get(`${baseUrl}/v2/admin/store/carte-preview.json?apiKey=${apiKey}`, params).then(unwrap);
}
